export default {
	title: "Mensajes",
	newMessage: "Nuevo Mensaje",
	resolve: "Resolver",
	resolved: "Resuelta",
	active: "Activa",
	noMessages: "Ningún mensaje",
	type: {
		ALERT: "Alerta",
		PENDENCY: "Pendencia",
		NOTE: "Observación",
		REPLENISHMENT: "Reposición",
	},
	severity: {
		LOW: "Baja",
		NORMAL: "Normal",
		CRITICAL: "Crítica",
	},
	form: {
		typeLabel: "Tipo",
		severityLabel: "Severidad",
		messageLabel: "Mensaje",
		messagePlaceholder: "Describa el mensaje...",
	},
	messages: {
		created: "Mensaje creado con éxito",
		resolved: "Mensaje resuelto",
		deleted: "Mensaje eliminado",
		createError: "Error al crear mensaje",
		deleteError: "Error al eliminar mensaje",
		loadError: "Error al cargar mensajes",
		resolveError: "Error al resolver mensaje",
	},
	resolvedBy: "Resuelto por {name} el {date}",
	createdBy: "Creado por {name}",
	dialogTitle: "Mensajes activos",
	viewMessages: "Ver mensajes",
	view: "Ver",
	hiddenContent: "Contenido protegido — haga clic en revelar para leer",
	revealShort: "Revelar",
	hideShort: "Ocultar",
	showResolved: "Mostrar mensajes resueltos",
	hideResolved: "Ocultar mensajes resueltos",
	noResolvedMessages: "Ningún mensaje resuelto",
	privacyNote: "Al cerrar, todos los mensajes vuelven a quedar ocultos.",
};
